import { UserIcon, GlobeIcon } from "lucide-react";

import { useSession } from "@/lib/session";

// Every panel says whose things it is listing. This is not decoration: an
// operator once read Admin's "Devices: 1" beside an empty Devices tab and filed
// a bug, because nothing on either page said the two numbers count different
// populations — the tab lists *your* devices, the admin table counts
// *everyone's*. The scope line is the fix, so it is a required part of a panel
// rather than something each page remembers to add.

// AccountScope marks a panel that shows only the signed-in account's own data.
export function AccountScope({ noun }: { noun: string }) {
  const session = useSession();
  return (
    <p
      data-testid="scope-note"
      className="flex items-center gap-1.5 text-sm text-muted-foreground"
    >
      <UserIcon className="size-3.5 shrink-0" />
      <span>
        {noun} belonging to{" "}
        <span className="font-medium text-foreground">{session?.email}</span> —
        this account only.
      </span>
    </p>
  );
}

// FleetScope marks an operator panel that spans the whole control plane.
export function FleetScope({ noun }: { noun: string }) {
  return (
    <p
      data-testid="scope-note"
      className="flex items-center gap-1.5 text-sm text-muted-foreground"
    >
      <GlobeIcon className="size-3.5 shrink-0" />
      <span>
        {noun} across{" "}
        <span className="font-medium text-foreground">every account</span> on
        this control plane — not just yours.
      </span>
    </p>
  );
}
